import { ForwardedRef, MutableRefObject, useCallback, useRef } from 'react';

export const scrollOffset = 112;

export const useScrollWithRefs = (scrollableCtn?: ForwardedRef<HTMLDivElement>) => {
  const refs: MutableRefObject<(HTMLHeadingElement | HTMLDivElement | null)[]> = useRef([]);
  const addToRefs = (el: HTMLHeadingElement | HTMLDivElement) => {
    if (el && !refs?.current.includes(el)) {
      refs?.current.push(el);
    }
  };

  const executeScroll = useCallback(
    (id: string) => {
      if (id && refs && refs?.current) {
        refs.current.map((el) => {
          const elPosition = el?.getBoundingClientRect()?.top || 0;
          const scrolledPosition =
            elPosition + (scrollableCtn as MutableRefObject<HTMLDivElement>).current.scrollTop - scrollOffset;
          if (el?.id === id && scrollableCtn) {
            (scrollableCtn as MutableRefObject<HTMLDivElement>).current?.scrollTo({
              top: scrolledPosition,
              behavior: 'smooth',
            });
          }
        });
      }
    },
    [refs, scrollableCtn],
  );

  return { executeScroll, addToRefs };
};
